(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessUnit', 'campaign', 'campaignRespondents', 'questionnaireTemplate'];

    function Controller($scope, $state, businessUnit, campaign, campaignRespondents, questionnaireTemplate) {


        $scope.businessUnit          = businessUnit;
        $scope.campaign              = campaign;
        $scope.campaignRespondents   = campaignRespondents;
        $scope.campaignQuestionnaire = questionnaireTemplate || null;

        if ($scope.campaignQuestionnaire === null) {
            console.error("No Questionnaire was provided with the campaign");
        }
        if (campaign && campaign.ODDInviteDetails && campaign.ODDInviteDetails.length > 0) {
            $scope.inviteDetails = campaign.ODDInviteDetails[0];
        } else {
            $scope.inviteDetails = null;
        }

        $scope.goToInviteDetails = function () {
            $state.go('odd.surveyCampaignEdit.inviteDetails', {
                ODDCampaignID: campaign.ODDCampaignID
            });
        };

        $scope.goToSection = function (section) {
            $state.go('odd.surveyCampaignEdit.section', {
                ODDQuestionnaireID: $scope.campaignQuestionnaire.ODDQuestionnaireID,
                ODDSectionID: section.ODDSectionID
            });
        };

        $scope.goToSectionListEdit = function () {
            $state.go('odd.surveyCampaignEdit.editSectionList');
        };

        // Add Section
        $scope.addSection = function () {

            $state.go('odd.surveyCampaignEdit.addSection', {
                ODDQuestionnaireID: $scope.campaignQuestionnaire.ODDQuestionnaireID,
                ODDCampaignID: $scope.campaign.ODDCampaignID
            });
        };

        $scope.goToRespondents = function () {
            if (!$scope.campaign.IsReadyToPublish) return;

            $state.go('odd.surveyCampaignEdit.respondentList', {
                ODDCampaignID: campaign.ODDCampaignID
            });
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', {
                ODDBusinessUnitID: businessUnit.ODDBusinessUnitID
            }, {
                reload: true
            });
        };

    }
})();